import React, { useState, useEffect } from 'react';

const ErrorBoundary = ({ children }) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const handleError = (error, errorInfo) => {
      setHasError(true);
      // You can log the error to an error reporting service
      console.error("Error caught by boundary:", error, errorInfo);
    };

    // Register error handler
    window.addEventListener('error', handleError);

    // Unregister error handler when component is unmounted
    return () => {
      window.removeEventListener('error', handleError);
    };
  }, []); // Empty dependency array ensures useEffect runs once during component mount

  if (hasError) {
    // You can render a fallback UI here
    return <div>Something went wrong with the chart.</div>;
  }

  return children;
};

export default ErrorBoundary;
